module.exports = __webpack_public_path__ + "img/helpfees.2d832360.svg";